<div class="bary-sidebar-footer">
  <div class="baryhr"></div>
  <!-- Ressources -->
  <mdb-accordion-item class="no-collapse" *ngIf="isModerator">
    <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_RESOURCES.path" routerLinkActive="active-link">
      <jhi-bary-icon icon="info-circle" [faDirective]="FaDirectiveEnum.FAS" class="fa-fw"></jhi-bary-icon>
      <span jhiTranslate="SIDEBAR.MODERATOR.RESOURCES">Ressources</span>
    </mdb-accordion-item-head>
  </mdb-accordion-item>

  <mdb-accordion-item class="no-collase">
    <mdb-accordion-item-head mdbWavesEffect [routerLink]="PATHS.LEGAL_MENTION.path" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <jhi-bary-icon icon="copyright" [faDirective]="FaDirectiveEnum.FAR"></jhi-bary-icon>
      <span jhiTranslate="SIDEBAR.FOOTER.LEGALNOTICES"></span>
    </mdb-accordion-item-head>
  </mdb-accordion-item>

  <mdb-accordion-item class="no-collase" *ngIf="isModerator">
    <mdb-accordion-item-head mdbWavesEffect (click)="callSupport()">
      <jhi-bary-icon icon="hands-helping" [faDirective]="FaDirectiveEnum.FAS"></jhi-bary-icon>
      <span jhiTranslate="SIDEBAR.FOOTER.SUPPORT"></span>
    </mdb-accordion-item-head>
  </mdb-accordion-item>

  <!-- /Legal Mention and FAQ -->
</div>
